import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import axios from 'src/app/Service/axios';
import { DataService } from 'src/app/Service/data.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
declare let $: any;

@Component({
  selector: 'menu_item',
  templateUrl: './menu_itemcomponent.html',
})
export class MenuItemComponent implements OnInit {
  comapnyName: any = '';
  fullName: any = '';
  acssess: any;
  isDektop: any;
  isOpen: boolean = false;
  isTrip_Save: boolean = false;
  isInCity: boolean = false;

  dashboardReportAccess = [
    'bReportAllNavigation',
    'bReportAllFunction',
    'bReportAllFule',
    'bReportAllFule',
    'bMobilesArGeoFance',
    'bMobileInGeoFenceHistory',
    'bMobilesInspection',
    'bServiceDelivery',
    'bMobilesFunctionInDomain',
    'bMobilesFunctionSD',
    'bRepairsReport',
    'bPeriodicVisits_Report',
    'bFInspection_Report',
    'bServiceReport',
    'bMobilesSalary',
    'bFleetYar_PaymentReport',
    'bFleetYar_GPSOFF_List',
    'bEnableDashboard',
    'bEnableDashboardProfessional',
    'bEnableDashboardHybrid',
    'bFisheries_Dashboard',
    'bFleetYar_Advance_PreregistratioDashboard',
  ];
  dashboardReportSubMenuAccess = {
    performance: ['bReportAllNavigation', 'bReportAllFunction'],
    fuel: ['bReportAllFule'],
    area: [
      'bMobilesArGeoFance',
      'bMobileInGeoFenceHistory',
      'bMobilesInspection',
      'bServiceDelivery',
      'bMobilesFunctionInDomain',
      'bMobilesFunctionSD',
    ],

    maintenance: [
      'bRepairsReport',
      'bPeriodicVisits_Report',
      'bFInspection_Report',
      'bServiceReport',
    ],

    finance: [
      'bMobilesSalary',
      'bMobilesImportTimesheet',
      'bFleetYar_PaymentReport',
    ],

    credit: ['bFleetYar_GPSOFF_List'],

    dashboard: [
      'bEnableDashboard',
      'bEnableDashboardProfessional',
      'bEnableDashboardHybrid',
      'bFisheries_Dashboard',
      'bFleetYar_Advance_PreregistratioDashboard',
    ],
  };
  eventsAndInputsAccess = ['bLiveJournal', 'bIOManage', 'bServiceDelivery'];
  fleetManagementAccess = [
    'bDonotShowMap',
    'bEnableAddID',
    'bFleetYar_Advance_PreregistrationManagment',
    'bFleetYar_Advance_TankerPreregistrationManagment',
    'bFleetYar_Installer',
    'bEnableAddCar',
    'bCarAdded',
    'bAbortion',
    'bServiceParts_Manage',
    'bAuthentication',
  ];
  userManagementAccess = [
    'bChangePass',
    'bEnableIntroducedMobile',
    'bUserManagment',
    'bUserManagment_OnlineUser',
    'bUserManagment_Group',
    'bSupport',
    'bMobileDomain_Save',
  ];
  transportationAccess = [
    'bTransit',
    'bTransit_Trip',
    'bTransit_Trip_Report',
    'bRoute_Management',
    'bRoute_Route_Schdeule',
    'bRoute_Reports',
    'bTransportation_Performance',
    'bRoute_Reports',
    'bRoute_Service_Dashboard',
    'bTaxiLon_ManageTrip',
    'bTaxiLon_City_ManageTrip',
    'bTaxiLon_Drivers',
    'bTaxiLon_Advertisement',
    'bTaxiLon_Trip_Save',
    'bTaxiLon_Trip_Search',
    'bTaxiLon_User_Search',
    'bTaxiLon_PaymentReport',
    'bTaxiLon_Reports',
    'bTaxiLon_DriverDebitCredit',
    'bTaxiLon_DriverCalendar',
    'bTaxiLon_Tariff',
    'bTaxiLon_TiketManagment',
    'bEmdadRan_ManageTrip',
    'bTaxiLon_Advertisement',
    'bEmdadRan_Resume',
    'bEmdadRan_Drivers',
    'bEmdadRan_User_Search',
    'bEmdadRan_Tariff',
    'bFleetYar_PaymentReport',
    'bEmdadRan_Dashboard',
    'bEmdadRan_DriverDebitCredit',
    'bEmdadRan_TiketManagment',
    'bBusEdit',
    'bBusPresenceAtStations',
    'bBusesPresenceAtStation',
    'bTaxi_LineManagment',
    'bSaveTaxiMeter',
    'bTaxiDashboard',
    'bTaxiSaveADS',
    'bTaxiADSReport',
    'bTaxi_Vacation_Managment',
    'bTaxi_OnlineDashboard',
    'bTaxi_OnlineDashboard',
    'bTaxi_OnlineDashboard',
  ];
  logisticsAccess = [
    'bTanker_Reports',
    'bTanker_Tanker_WaterClient',
    'bTanker_List',
    'bTanker_Shower_Edit',
    'bTanker_Dashboard',
    'bRent',
    'bRent_Report',
    'bRent_Active',
    'bRent_BaseInfo',
    'bTelemetry',
    'bTelemetry_ChargeStatus',
  ];
  cctvAccess = [
    'bVideoSurveillance',
    'bVideoSurveillance_Parking',
    'bVideoSurveillance_LastUpload',
    // 'bVideoSurveillance_Dashboard',
    'bVideoSurveillance_Events',
  ];
  tripAutomationAccess = [
    'bPeysepar',
    'OffitialTrip_Trip',
    'OffitialTrip_Search',
    'OffitialTrip_FunctionReport',
    'OffitialTrip_FinanceReport',
    'OffitialTrip_UserManagment',
    'OffitialTrip_BaseInfo',
  ];
  madonikAccess = [
    'bSchoolService_MobileDomain',
    'bSchoolService_UserMobileDomain',
    'bSchoolService_Student_Save',
    'bSchool_Manager_SuperClass',
    'bSchool_News',
    'bSchoolService_Student_Search',
    'bSchoolService_SchoolAbsence',
    'Madonik_EntryExit',
    'bSchool_PM_ManageSchool_Events',
    'bSchool_PM_ManageSchool_VoiceMessage',
    'bSchoolService_DailyReports',
    'bSchool_AttendingExams',
    'bSchoolService_Absences',
    'bSchoolService_Dashboard',
    'bSchool_School_Dashboard',
    'bSchoolService_MonitoringDashboard',
    'bSchoolService_Tiket4School',
    'bSchoolService_Tiket4Rayan',
    'bSchool_BuffetSave',
    'bSchool_PrebuyReport',
    'bSchool_BuffetReport',
    'bSchoolVoice_CartableDefine',
    'bSchoolVoice_Request_Save',
    'bSchool_Request_Cartable',
    'bSchoolVoice_Request_Search',
    'bSchoolVoice_Request_Dashboard',
    'bMadonik_Tariff',
    'bSchoolService_DetermineDriver',
    'bSchoolService_DriverPlan',
    'bSchoolService_ServiceRequest',
    'bSchoolService_ChangeAddress',
    'bSchoolService_Absence',
    'bSchoolService_DriverFunction',
    'bSchoolService_DashboardLive',
    'bSchoolService_Tiket',
    'bMadonik_ServiceContract',
    'bSchool_School_Financial_Report',
    'bSchool_School_Financial_Report',
  ];
  helpContactAccess = ['bAbout', 'bAboutCompany', 'bShop'];

  @HostBinding('class') classes = 'MenuItem';
  @Output() modalMenu = new EventEmitter<any>();
  @Output() tripModal = new EventEmitter<boolean>();

  constructor(
    private notifyService: NotificationService,
    private router: Router,
    private otherService: OtherService,
    private el: ElementRef,
    private deviceService: DeviceDetectorService,
    private dataService: DataService,
    private gurdService: GurdServiceService,
  ) {
    this.isDektop = this.deviceService.isDesktop();
  }

  ngOnInit(): void {
    this.comapnyName = this.gurdService.decrypt(
      window.localStorage.getItem('companyName')!,
    );
    this.fullName = this.gurdService.decrypt(
      window.localStorage.getItem('FullName')!,
    );
    var data = window.localStorage.getItem('menu') as any;
    this.acssess = JSON.parse(this.gurdService.decrypt(data));
  }

  ngAfterViewInit(): void {
    // document.addEventListener("DOMContentLoaded", function () {

    // make it as accordion for smaller screens

    setTimeout(() => {
      if (window.innerWidth < 992) {
        document
          .querySelectorAll('.sidebar .nav-link')
          .forEach(function (element) {
            element.addEventListener('click', function (e) {
              let nextEl = element.nextElementSibling as HTMLElement;

              let parentEl = element.parentElement as HTMLElement;

              let allSubmenus_array = parentEl.querySelectorAll('.submenu');

              if (nextEl && nextEl.classList.contains('submenu')) {
                e.preventDefault();

                if (nextEl.style.display == 'block') {
                  nextEl.style.display = 'none';
                } else {
                  nextEl.style.display = 'block';
                }
              }
            });
          });
      }
    }, 500);

    // });
  }

  clickMethod(name: string) {
    $.confirm({
      title: `آیا از خروج حساب کاربری اطمینان دارید؟`,
      content: '',
      type: 'red',
      buttons: {
        ok: {
          text: 'تایید',
          btnClass: 'btn-danger',
          keys: ['enter'],
          action: () => {
            this.otherService.removeLocalStorage();
            this.router.navigate(['login']);
            window.location.reload();
          },
        },
        cancel: {
          text: 'لغو',
        },
      },
    });
  }

  getLink = async (type: number) => {
    this.otherService.getLink(type);
  };

  sabt() {
    if (this.acssess.bAddGPS && this.acssess.bAddNGPS) {
      $('#exampleModal').modal('show');
      var tooltip = $('#map_tooltip');
      tooltip.tooltip('hide');
    } else if (this.acssess.bAddGPS && !this.acssess.bAddNGPS) {
      this.router.navigate([`entryCar/1`]);
    } else if (!this.acssess.bAddGPS && this.acssess.bAddNGPS) {
      this.router.navigate([`entryCar/2`]);
    }
  }

  sabtReport(id: any) {
    $('#menuModal').modal('show');

    var tooltip = $('#map_tooltip');

    tooltip.tooltip('hide');

    this.modalMenu.emit(id);
  }

  openExelUploder() {
    $('#exelUploder').modal('show');
    var tooltip = $('#map_tooltip');
    tooltip.tooltip('hide');
  }

  close() {
    let tag = document.getElementsByTagName('menu_item') as any;
    tag[0].classList.add('d-none');
    let bgTag = document.getElementById('bg-menu') as any;
    bgTag.classList.add('d-none');
    if (this.isDektop) {
      $('#test').css('right', '0%');
    }
  }

  company = async () => {
    const resp = await axios.post(
      `GetCompanyInfo?iSystemUser=${this.gurdService.decrypt(window.localStorage.getItem('ID')!)}`,
    );
    window.open(resp.data, '_blank');
  };

  accessibility(...array: string[]): boolean {
    let result = false;
    for (let i = 0; i < array.length; i++) {
      if (this.acssess[array[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get dashboardReportAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.dashboardReportAccess.length; i++) {
      if (this.acssess[this.dashboardReportAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get eventsAndInputsAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.eventsAndInputsAccess.length; i++) {
      if (this.acssess[this.eventsAndInputsAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get fleetManagementAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.fleetManagementAccess.length; i++) {
      if (this.acssess[this.fleetManagementAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get userManagementAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.userManagementAccess.length; i++) {
      if (this.acssess[this.userManagementAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get transportationAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.transportationAccess.length; i++) {
      if (this.acssess[this.transportationAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get logisticsAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.logisticsAccess.length; i++) {
      if (this.acssess[this.logisticsAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get cctvAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.cctvAccess.length; i++) {
      if (this.acssess[this.cctvAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get tripAutomationAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.tripAutomationAccess.length; i++) {
      if (this.acssess[this.tripAutomationAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get madonikAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.madonikAccess.length; i++) {
      if (this.acssess[this.madonikAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  get helpContactAccessibility(): boolean {
    let result = false;
    for (let i = 0; i < this.helpContactAccess.length; i++) {
      if (this.acssess[this.helpContactAccess[i]] == true && !result) {
        result = true;
        break;
      }
    }
    return result;
  }

  hasAccess(accesses: string[]): boolean {
    return accesses.some((access) => this.acssess[access]);
  }

  async holidayModal() {
    this.otherService.holiday_Status(true);

    // this.holidayYear = momentJalaali().locale('fa').format('jYYYY');

    // let model = this.otherService.stringNumberToNumber({

    //   strSession: `${this.gurdService.decrypt(localStorage.getItem('Session')!)}`,

    //   iSystemUser: this.gurdService.decrypt(window.localStorage.getItem('ID')!),

    //   iYear: this.holidayYear

    // })

    // let res = JSON.parse((await axios.post(`Holidays_List`, model)).data.toString());

    // this.holidayData.emit(res);

    // $('#holidaysModal').modal('show');

    // var tooltip = $('#map_tooltip');

    // tooltip.tooltip('hide');
  }

  tripModal_Open() {
    this.tripModal.emit(true);
  }
}
